import Tracking from "../uidispatcherapi/Tracking";
import { HOOK_SKIPPED } from "./redirectUtil";

const redirectTier12CustomersHook = (state, sessionStore, handler) => {
	const tierLevel = sessionStore.getCustomerTierLevel();
	const isTier12 = tierLevel === "1" || tierLevel === "2";

	if (state.routeParams.invisibleForTier12 && isTier12) {
		Tracking.trackStructuredEvent("platform", "uidispatcher", "tierDisallowedAccess", {
			tags: {
				path: state.path,
			},
		});
		handler.transitionTo("/");
		return {
			checkNext: true,
			didRedirect: true,
		};
	}

	return HOOK_SKIPPED;
};

export const RedirectTiers = {
	hook: redirectTier12CustomersHook,
};
